import React, {Component} from 'react';
import {graphql} from 'react-relay'
import {commitMutation} from 'react-relay'
import {longTimeoutEnvironment} from '../../RelayEnvironment'
import '../../css/mapstyle.css'
import {SaveToStoryList, ButtonComponent} from "common-components";

class SaveMapPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mapTitle: "",
            sectionIds: [],
            addToPublicFeed: false,
            addToFavorites: false,
            savedMap: false,
            savingMap: false
        }
    }

    handlePublishBoardAsStoryStep2 = (sectionIds, addToFavorites, addToPublicFeed) => {
        this.setState({sectionIds, addToFavorites, addToPublicFeed})
    };

    saveMapNext = () => {
        this.props.history.push({
            pathname:this.props.history.location.pathname,
            search:this.props.history.location.search,
            hash: "#saveMap"
        })
    };

    onChangeTitle = (e) => {
        if (e.target.value) {
            this.setState({mapTitle: e.target.value})
        } else {
            this.setState({mapTitle: ""})
        }
    };

    handleSaveMap = () => {
        const { indicatorsObjectArray } = this.props;

        if (this.state.savingMap === true || this.state.savedMap === true) {
            return;
        }
        this.setState({savingMap: true});
        const mutation = graphql`
            mutation SaveMapPopupMutation($input: CreateMapCardInput!) {
            createMapCard(input: $input) {
                mapCardNode {
                    id configuration {
                        title
                    }
                }
            }
        }`;
        const pngUrl = this.props.getMapPngUrl();
        const centerAndzoom = this.props.getMapCenterAndZoom();

        const variables = {
            "input": {
                "name": this.state.mapTitle,
                "thumbnailImage": pngUrl,
                "savedAreaId": this.props.savedAreaIdSelected,
                "indicators": indicatorsObjectArray,
                "sectionIds": this.state.sectionIds,
                "zoom": centerAndzoom.zoom,
                "center": {
                    "lng": centerAndzoom.centerLonLat[0],
                    "lat": centerAndzoom.centerLonLat[1]
                },
                "addToPublicFeed": this.state.addToPublicFeed,
                "addToFavorites": this.state.addToFavorites
            }
        };
        //console.log("input values for save map",JSON.stringify(variables))

        // TODO: add error handling and better responsive progress dialogue
        commitMutation(
            longTimeoutEnvironment,
            {
                mutation,
                variables,
                onCompleted: (response, errors) => {
                    console.log('Response received from server.');
                    this.setState({savedMap: true, mapTitle: "", sectionIds: [], addToPublicFeed: false, savingMap: false});
                },
                onError: (err) => {
                    console.error(err);
                    alert('Error saving map');
                    this.setState({savedMap: false, savingMap: false});
                },
            },
        );
    };

    render() {
        const {history: {location}} = this.props;
        const {savedMap, mapTitle, savingMap} = this.state;
        return (

            <div>
                <div className={"row mx-0 " + (location.hash === "#save" ? "showMenu h-100" :
                    ((location.hash === "#saveMap") ? " hideLeft hideSave" : " hideSave"))}>
                    <div className={"col-12 left-nav" + (location.hash === "#save" ? " h-100" : "")}>
                        <div className="title mt-4">
                            <h3 className="font-20 pb-4">Map Title</h3>
                            <div className="edit-card-right-menu">
                                <ButtonComponent
                                    disabled={!mapTitle}
                                    buttonType="subtle"
                                    buttonTitle="Next"
                                    onClick={this.saveMapNext} />
                            </div>
                        </div>
                        <div className="bsui-leftnavmenu-open">
                            <ul>
                                <li className="left-menu-header pb-4 pt-0 pl-0">
                                    <span className="left-menu-title">Give your map a title</span>
                                </li>
                                <li className="left-menu-header pb-4 pt-0 pl-0">
                                    <div>
                                        <input className="form-control"
                                               type="text"
                                               name="cardTitle"
                                               placeholder="Ex. “Health Indicators in Our Area”"
                                               onChange={this.onChangeTitle}
                                               value={mapTitle}
                                               autoComplete="off"
                                        />
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className={"row mx-0 " + (location.hash === "#saveMap" ? "showMenu h-100" : "hideSave")}>
                    <div className={"col-12 left-nav p-0" + (location.hash === "#saveMap" ? " h-100" : "")}>
                        <div className="title mt-4 mx-3">
                            <h3 className="font-20 pb-4">Save to</h3>
                            <div className="edit-card-right-menu">
                                <ButtonComponent
                                    buttonType="subtle"
                                    disabled={savingMap}
                                    buttonState={savedMap ? "saved" : ""}
                                    buttonTitle={savedMap ? 'SAVED' : savingMap ? "SAVING" : "SAVE"}
                                    onClick={this.handleSaveMap} />
                            </div>
                        </div>
                        <div className="bsui-leftnavmenu-open pt-0">
                            <SaveToStoryList
                                isCollection={true}
                                userData={this.props.userData}
                                handlePublishBoardAsStory={this.handlePublishBoardAsStoryStep2}
                                cancelPublish={this.hidePopUp}
                                fromStory={true}
                            />
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default SaveMapPopup;



// WEBPACK FOOTER //
// ./src/components/SaveMapPopup/SaveMapPopup.js